import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import Logo from '@wix/da-ds/pkg/Logo';
const LogoWithCoreLevel = (props)=>{
    return /*#__PURE__*/ React.createElement(Logo, _object_spread_props(_object_spread({}, props), {
        allowCustomization: true
    }));
};
LogoWithCoreLevel.displayName = 'LogoWithCoreLevel';
export default LogoWithCoreLevel;
